// extracted by mini-css-extract-plugin
export default {"termSubheader":"index_termSubheader__5eKOO"};